import InternalProgress from './Progress'

type InternalProgressType = typeof InternalProgress
export type ProgressInterface = InternalProgressType

const Progress = InternalProgress as ProgressInterface
export default Progress
